export default __webpack_public_path__ + "static/derrick-16cae357b18512deb1fa88c79941044e.jpg";